<!-- 跳转到嘟电影的H5 -->

<script>
import { getMovieIndexUrl } from "@/api/sys-api";
import { Dialog } from "vant";
import { mall_wx_get_user_info } from "@/api/login";

export default {
  name: "movie",

  created() {
    mall_wx_get_user_info().then(() => {
      getMovieIndexUrl(this.$store.getters.city_code + "00", "").then((res) => {
        if (res.code === 0) {
          window.location = res.data;
        } else {
          Dialog({ message: res.msg });
        }
      });
    });
  },

  methods: {
    forbidBack() {
      window.history.pushState("forward", null, "#");
      window.history.forward(1);
    },
  },

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.forbidBack, false);
      this.forbidBack();
    }
  },

  destroyed() {
    window.removeEventListener("popstate", this.forbidBack, false);
  },
};
</script>

<style scoped></style>
